import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import constants from 'lib/constants';

const FooterWrapper = styled.div`
  background: #fff;
  width: 100%;
  .Layouts-Public-Footer--topRowContainer {
    border-top: 1px solid #e1eaf2;
    width: 100%;
  }
  .Layouts-Public-Footer--topRow {
    width: ${p => p.theme.appWidth};
    height: 150px;
    padding: 10px;
    max-width: 100%;
  }
  .Layouts-Public-Footer--ul {
    list-style-type: none;
  }
  .Layouts-Public-Footer--liTitle {
  }
  .Layouts-Public-Footer--li {
    font-size: 14px;
    margin-bottom: 2px;

    &,
    a {
      color: #000 !important;
    }
  }
  .Layouts-Public-Footer--cclaritiLogo {
    height: 56px;
  }
  .Layouts-Public-Footer--bottomRowContainer {
    border-top: 3px solid #e1eaf2;
    width: 100%;
  }
  .Layouts-Public-Footer--bottomRow {
    width: ${p => p.theme.appWidth};
    height: 50px;
    font-size: 14px;
    max-width: 100%;
  }
`;

export class Footer extends React.Component {
  renderTopRow = () => (
    <div className="Layouts-Public-Footer--topRowContainer">
      <Row type="flex" align="middle" justify="center" className="mx-auto Layouts-Public-Footer--topRow">
        <Col xs={24} sm={6}>
          <img src={constants.images.logoBlack} alt="cclariti" className="Layouts-Public-Footer--cclaritiLogo" />
        </Col>
        <Col xs={24} sm={6} />
        <Col xs={24} sm={6} />
        <Col xs={24} sm={6}>
          <ul className="Layouts-Public-Footer--ul">
            <li className="Layouts-Public-Footer--li">
              <Link to="/contact">Contact Us</Link>
            </li>
            <li className="Layouts-Public-Footer--li">
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li className="Layouts-Public-Footer--li">
              <Link to="/terms">Terms of Service</Link>
            </li>
          </ul>
        </Col>
      </Row>
    </div>
  );

  renderBottomRow = () => (
    <div className="Layouts-Public-Footer--bottomRowContainer">
      <Row type="flex" align="middle" justify="center" className="mx-auto Layouts-Public-Footer--bottomRow">
        Copyright &copy; 2019 Company Co. All rights reserved
      </Row>
    </div>
  );

  render() {
    return (
      <FooterWrapper className="Layouts-Public-Footer--container">
        {this.renderTopRow()}
        {this.renderBottomRow()}
      </FooterWrapper>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/BlankLayout/Footer/index.js